type Address =
  | string
  | {
      locality?: string;
      neighbourhood?: string;
      number?: string;
      reference?: string;
      road?: string;
      [key: string]: any;
    };

export function formatAddress(address: Address): string {
  // Caso seja uma string (endereço delivery simples)
  if (typeof address === 'string') {
    return address;
  }

  // Caso seja um objeto vazio
  if (typeof address === 'object' && Object.keys(address).length === 0) {
    return 'Retirada no Local';
  }

  // Caso seja um objeto preenchido (endereçado)
  if (typeof address === 'object') {
    const { road, number, neighbourhood, reference } = address;

    // Se não houver 'road', consideramos como retirada no local
    if (!road) return 'Retirada no Local';

    // Montagem do endereço formatado
    return `${road}, Nº ${number || 'S/N'}${neighbourhood ? `, ${neighbourhood}` : ''}${reference ? ` - ${reference}` : ''}`;
  }

  return 'Endereço inválido';
}
